import React from 'react'
import PropTypes from 'prop-types'
import { Link, navigateTo } from 'navigation'
import { HumiLab, DialogueBox, Button, Input } from 'components/UIElements'
import { check, DCH } from '../../../assets/assets'
import '../../Profile/routes/ChangePassword/stylesheets/changePassword.scss'

class ChangePasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      eight: false,
      uppercase: false,
      lowercase: false,
      number: false,
      showSuccess: false
    }
  }

  componentDidMount() {
    const { clearPasswordError, resetPasswordState } = this.props
    clearPasswordError()
    resetPasswordState()
  }

  validate = password => {
    const isEightCharacters = /^.{8,}$/g
    const hasUppercase = /^(.*[A-Z].*)$/g
    const hasLowercase = /^(.*[a-z].*)$/g
    const hasNumber = /^(.*\d.*)$/g

    if (password.match(isEightCharacters)) {
      this.setState({ eight: true })
    } else {
      this.setState({ eight: false })
    }
    if (password.match(hasUppercase)) {
      this.setState({ uppercase: true })
    } else {
      this.setState({ uppercase: false })
    }
    if (password.match(hasLowercase)) {
      this.setState({ lowercase: true })
    } else {
      this.setState({ lowercase: false })
    }
    if (password.match(hasNumber)) {
      this.setState({ number: true })
    } else {
      this.setState({ number: false })
    }
  }

  onSetPassword = () => {
    const { setNewpasswordWithToken, password } = this.props
    // setNewpasswordWithToken(password)
    this.setState({ showSuccess: true })
  }

  onRenderChangePasswordContent = () => {
    const { updatePassword, password, passwordError } = this.props
    const { newPassword, newPasswordConfirmation } = password
    const { eight, uppercase, lowercase, number } = this.state
    return (
      <div>
        <h3>Create a new password</h3>
        <div className='validations'>
          <p>
            <span>Make sure to include</span>
          </p>
          <p>
            {check(eight ? 'check' : '')}
            <span>8 characters minimum</span>
          </p>
          <p>
            {check(uppercase ? 'check' : '')}
            <span>One uppercase letter</span>
          </p>
          <p>
            {check(lowercase ? 'check' : '')}
            <span>One lowercase letter</span>
          </p>
          <p>
            {check(number ? 'check' : '')}
            <span>One number</span>
          </p>
        </div>
        <Input
          id='user-password'
          label='Type Password'
          type='password'
          value={newPassword}
          onChange={value => {
            this.validate(value)
            updatePassword('newPassword', value)
          }}
        />
        <Input
          id='user-password-confirmation'
          label='Retype Password'
          type='password'
          value={newPasswordConfirmation}
          onChange={value => updatePassword('newPasswordConfirmation', value)}
          pretext={
            passwordError === 'Passwords do not match'
              ? passwordError
              : '' || ''
          }
        />
        <Button
          content='Set Password'
          disabled={
            !eight ||
            !uppercase ||
            !lowercase ||
            !number ||
            !newPasswordConfirmation.length > 0
          }
          onClick={() => {
            this.onSetPassword()
          }}
        />
        <div>
          <Link to='/login'>Cancel</Link>
        </div>
      </div>
    )
  }

  onRenderSuccess = () => {
    return (
      <div className='success'>
        <img src={DCH} alt='DCH-logo' />
        <h3>
          {check('check')}
          <span>Success! Your password has been reset.</span>
        </h3>
        <p>Now let's continue with your study!</p>
        <Button
          content='Go to My Activities'
          onClick={() => {
            navigateTo('/my-activities')
          }}
        />
        <Button link content='or Check out our mobile app' />
      </div>
    )
  }

  render() {
    // const { password, setNewPasswordWithToken } = this.props
    const { showSuccess } = this.state

    return (
      <div className='change-password page'>
        <HumiLab />
        <DialogueBox>
          {showSuccess
            ? this.onRenderSuccess()
            : this.onRenderChangePasswordContent()}
        </DialogueBox>
      </div>
    )
  }
}

export default ChangePasswordPage

ChangePasswordPage.propTypes = {
  clearPasswordError: PropTypes.func,
  isTempPassword: PropTypes.bool,
  needsConsent: PropTypes.bool,
  password: PropTypes.shape({
    newPassword: PropTypes.string,
    newPasswordConfirmation: PropTypes.string
  }),
  resetPasswordState: PropTypes.func,
  setNewPassword: PropTypes.func,
  tempPassword: PropTypes.string,
  updatePassword: PropTypes.func
}
